import * as React from 'react';
import { IconProps, SIZE_MAP } from '../types';
import { cn } from '../../../utils/cn';

const AlertCircleFilledIcon = ({ size = 'lg', className, ...props }: IconProps) => {
  const px = SIZE_MAP[size];

  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-primary', className)}
      {...props}
    >
      <path
        d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25Z"
        fill="currentColor"
      />
      <path
        d="M12.0098 15.25C12.424 15.25 12.7598 15.5858 12.7598 16C12.7598 16.4142 12.424 16.75 12.0098 16.75H12C11.5858 16.75 11.25 16.4142 11.25 16C11.25 15.5858 11.5858 15.25 12 15.25H12.0098ZM11.25 12V8C11.25 7.58579 11.5858 7.25 12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V12C12.75 12.4142 12.4142 12.75 12 12.75C11.5858 12.75 11.25 12.4142 11.25 12Z"
        fill="white"
      />
    </svg>
  );
};

export default AlertCircleFilledIcon;
